export const formContentStyle = {
	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '16px',
		marginBottom: '16px',
	},

	password: {
		position: 'relative',
	},

	passwordIcon: {
		'& svg path': {
			fill: 'var(--neutral-200)',
		},

		'& .Mui-error svg path': {
			fill: 'var(--error-500)',
		},
	},

	button: {
		height: '44px',
		marginTop: '40px',
		fontWeight: 700,
		'& .MuiButton-endIcon': {
			transform: 'rotate(180deg)',
		},
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 120px',
			},

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px',
			},
		},
	},
};
